//**************************************************************/
import { Injectable } from "@angular/core";
import {Observable, Subject, of, from } from 'rxjs';
//**************************************************************/
import { HttpClient } from "@angular/common/http";
//**************************************************************
// Moments Module
import * as moment from 'moment';
//**************************************************************/
@Injectable()
//**************************************************************/
export class appfunctions
    {
        xxxx: string;
        //**************************************************************/
        constructor( 
                        private http: HttpClient
                    )
            {
            
            }
        //**************************************************************/
        createuniqueid( nonumber: number )
        {     
            var i: number;
            var participantid: string;
            var randomid: number;
            
            participantid = "";

            for ( i = 1; i <= nonumber; i++)
                {
                    randomid = Math.floor( Math.random() * 10 );
                    participantid = participantid + (randomid.toString()).trim();
                }

            return participantid;
        }
        //**************************************************************
        covertdateformat( localcountry: string )
            {
                var localeData  = moment.localeData( localcountry );  // associate with country
                var format      = localeData.longDateFormat('L');
                format          = format.toLocaleLowerCase()
        
                var re = /m/gi; 
        
                var revisedateformat = format.replace(re, "M"); 
            
                return revisedateformat;
        
            }
        //**************************************************************
        convert_firestoretimestamp_to_data( seleconds: number, nanoseconds: number )
            {

                // S 1675404569  NS 137000000
                const fireBaseTime = new Date( seleconds * 1000 + 137000000 / 1000000 );
                     
                return  fireBaseTime;
            }
        //**************************************************************
        // Validate Address via Google Maps
        googlevalidateaddress( streetno: string, street: string, suburb: string, city: string, country: string )
            {
                let baseaddress  = streetno + ' ' + street + ' ' + suburb + ' ' + city + ' ' + country;
                
                let arrayOfKeyValues  = baseaddress.split(' ');
                let notran            = arrayOfKeyValues.length;
            
                if ( notran > 0 ) 
                    {
                        //*************************************************************
                        var subject = new Subject<string>();
                        //*************************************************************
                        var googleaddress: string;
                
                        // Get address in Google Format 
                        googleaddress = '';

                        for (let i = 0; i < notran; i++)  // Report Lines
                            {    
                                // Report Line - separated by #
                                var addressitem  = arrayOfKeyValues[i]
                                googleaddress = googleaddress + addressitem + '+';
                            }

                        googleaddress = googleaddress.slice(0,googleaddress.length-1);
                        //*************************************************************
                        // Google API
                        // ** Determine whether address is a valid address according to Google Maps
                        let apiRoot = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + googleaddress + "&key=AIzaSyDXP7eW--Hq-7TLA_t4evfg2-_PvgxO8fE";  

                        this.http.get<any>( apiRoot).subscribe( mapdata =>  { 
                                                                                
                                                                                    var status: string;
                                                                                    status          = mapdata.status;
                                                                                    status          = status.toUpperCase();

                                                                                    var loctype: string;
                                                                                    loctype         = mapdata.results[0].geometry.location_type;
                                                                                    loctype         = loctype.toUpperCase();

                                                                                    var matchtype: boolean;
                                                                                    matchtype       = mapdata.results[0].partial_match;
        
                                                                                    //console.log( 'Status:' + status + ' ' + 'Loctype:' + loctype + ' ' + 'MatchType :' + matchtype )

                                                                                    var mapaddress  = mapdata.results[0].formatted_address;
                                                                                    //console.log( mapaddress )   
                                                                                    if ( ( status == 'OK' ) &&  ( loctype == 'ROOFTOP' ) && ( matchtype == undefined ) )
                                                                                        {
                                                                                            this.xxxx = mapaddress
                                                                                           
                                                                                           // console.log( this.xxxx )    
                                                                                            
                                                                                           subject.next(this.xxxx);

                                                                                           return subject.asObservable();   
                                                                                        }
                                                                                    else
                                                                                        {

                                                                                           this.xxxx = '0';

                                                                                           //return  this.xxxx 

                                                                                           subject.next(this.xxxx);

                                                                                           return subject.asObservable();   
                                                                                        }

                                                                                    }

                                                                                     
                                                                    )

                                                                            
                }
                
        }
        //*******************************************************
        googlevalidateaddressTest( googleaddress: string ): Observable<string>
        {
            var subject = new Subject<string>();
            //*************************************************************
            // Google API
            // ** Determine whether address is a valid address according to Google Maps
            let apiRoot = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + googleaddress + "&key=AIzaSyDXP7eW--Hq-7TLA_t4evfg2-_PvgxO8fE";  

            this.http.get<any>( apiRoot).subscribe( mapdata =>  { 
                                                                        //console.log( mapdata )
                                                                        var status: string;
                                                                        status          = mapdata.status;
                                                                        status          = status.toUpperCase();

                                                                        var loctype: string;
                                                                        loctype         = mapdata.results[0].geometry.location_type;
                                                                        loctype         = loctype.toUpperCase();

                                                                        var matchtype: boolean;
                                                                        matchtype       = mapdata.results[0].partial_match;

                                                                        //console.log( 'Status:' + status + ' ' + 'Loctype:' + loctype + ' ' + 'MatchType :' + matchtype )

                                                                        var countryaddress  = mapdata.results[0].address_components[5].long_name;
                                                                        var mapaddress      = mapdata.results[0].formatted_address + '#' + countryaddress
                                                                        //console.log( mapaddress )
                                                                       
                                                                        if ( ( status == 'OK' ) &&  ( loctype == 'ROOFTOP' || loctype == 'RANGE_INTERPOLATED') ) //&& ( matchtype == undefined ) )
                                                                            {
                                                                                subject.next( mapaddress );
                                                                            }
                                                                        else
                                                                            {
                                                                                subject.next('0');
                                                                            }

                                                                        }

                                                                            
                                                        )
                return subject.asObservable();                                                      
                                                                        
            }
            
    }
    //*******************************************************
    